const request = async (path, params = {}) => {
  const query = new URLSearchParams(Object.entries(params).filter(([, value]) => value != null && value !== '')).toString();
  const token = localStorage.getItem('token');
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || ''}${path}${query ? `?${query}` : ''}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) {
    const error = new Error(`Options request failed: ${response.status}`);
    error.response = { data: await response.json().catch(() => ({})) };
    throw error;
  }
  return response.json();
};
const mutate = async (path, method, body) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || ''}${path}`, {
    method,
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(body ? { 'Content-Type': 'application/json' } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!response.ok) {
    const error = new Error(`Options request failed: ${response.status}`);
    error.response = { status: response.status, data: await response.json().catch(() => ({})) };
    throw error;
  }
  return response.status === 204 ? null : response.json();
};

export const getOptionsScanner = () => request('/api/ativos/options/scanner');
export const getOptionsVolatility = ticker => request(`/api/options/volatility/${encodeURIComponent(ticker)}`);
export const getOptionsChain = (ticker, purpose) => request(`/api/options/chain/${encodeURIComponent(ticker)}`, { purpose });
export const getOptionsChecklist = (ticker, setup, mode, purpose) => request(`/api/options/checklist/${encodeURIComponent(ticker)}`, { setup, mode, purpose });
export const getOptionsGrid = (ticker, params = {}) => request(`/api/options/grid/${encodeURIComponent(ticker)}`, params);
export const refreshOptionsGrid = ticker => mutate(`/api/options/grid/${encodeURIComponent(ticker)}/refresh`, 'POST');
export const getOptionsWatchlist = () => request('/api/options/watchlist');
export const addOptionsWatchlist = optionSymbol => mutate('/api/options/watchlist', 'POST', { option_symbol: optionSymbol });
export const removeOptionsWatchlist = optionSymbol => mutate(`/api/options/watchlist/${encodeURIComponent(optionSymbol)}`, 'DELETE');